import {
  UserFragment,
  UsersQuery,
  useUsersQuery,
  withStandardListHook,
} from '@spotify/confidence-graphql';

export const useUsers = withStandardListHook<UsersQuery, UserFragment, 'users'>(
  useUsersQuery,
  'users',
);
